module.exports = __webpack_public_path__ + "static/img/maxwell-award.8b119e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maxwell-award.png
// module id = 0ztH
// module chunks = 1